import { Injectable } from '@angular/core';
import { FileModel } from '@shared';

@Injectable()
export class FileSanitizerService {
	public constructor() {}

	public keysValuesToLowerCase(file: FileModel, valuesOfKeysToMakeLowerCase?: string[]): FileModel {
		const objectKeysValuesToLowerCase = (input: any) => {
			let val: any;

			// if it's object, continue; check for !null is rquired, because it is consider object as well
			if (typeof input !== 'object' && input !== null && !Array.isArray(input)) {
				return input;
			}
			// if it's an array of objects, go deeper
			if (Array.isArray(input) && input !== null) {
				return input.map(objectKeysValuesToLowerCase);
			}

			return Object.keys(input).reduce((newObj, key) => {
				if (valuesOfKeysToMakeLowerCase && valuesOfKeysToMakeLowerCase.includes(key)) {
					val = Array.isArray(input[key])
						? input[key].map((v: string) => v.toLowerCase())
						: input[key].toLowerCase();
				} else {
					val = input[key];
				}

				const newVal = typeof val === 'object' && val !== null ? objectKeysValuesToLowerCase(val) : val;
				newObj[key.toLowerCase()] = newVal;
				return newObj;
			}, {});
		};

		// for now we specify inhere what sections to apply the lower case to
		file.FusionEntities = objectKeysValuesToLowerCase(file.FusionEntities);
		file.FusionDataColumns = objectKeysValuesToLowerCase(file.FusionDataColumns);
		file.FusionDataTables = objectKeysValuesToLowerCase(file.FusionDataTables);
		file.TABLE_DATA = objectKeysValuesToLowerCase(file.TABLE_DATA);
		file.FusionReferenceTables = objectKeysValuesToLowerCase(file.FusionReferenceTables);

		return file;
	}
}
